<script setup lang="ts">
import AuctionNavFallback from './AuctionNavFallback.vue'
import AuctionNavInner from './AuctionNavInner.vue'
</script>

<template>
  <Suspense>
    <template #default>
      <AuctionNavInner />
    </template>
    <template #fallback>
      <AuctionNavFallback />
    </template>
  </Suspense>
</template>
